import { makeStyles } from '@material-ui/core';

import Colors from '../../../../constants/Colors';

export default makeStyles(() => ({
  root: {
    color: Colors.PRIMARY_FONT_COLOR,
  },
  iconRoot: {
    color: Colors.PRIMARY_COLOR,
  },
}));
